import { Button, Card, Grid, Row, Typography } from "antd";
import { Content } from "antd/es/layout/layout";
import styled from "styled-components";

const { Paragraph } = Typography;
const {useBreakpoint} = Grid

export const StyledButton = styled(Button)`
  /* border-top: 1px;
  border-left: 1px;
  border-right: 1px; */

  /* border-radius: 0px; */
  /* border-color: "#192238"; */

  &&.ant-btn-primary {
    color: white;
    background-color: "#192238";
    /* border-color: "#192238"; */
    &:hover {
      color: #192238;
      border-color: #192238;
      background-color: white;
    }
  }
`;

export const StyledList = styled.div`
  font-family: "Inter";
  

  ul {
    list-style-type: disc;
    line-height: 0.5;
    padding-left: 20px;

    li {
      line-height: 1.5;
    }
  }
`;

export const StyledNewsCard = styled(Card)`
  width:  100%;
  /* margin-right: 10px; */
  .ant-card-body {  
    height: 190px;
  }
  @media (max-width: 2560px) {
    width: 100% !important;
    height: 290px !important;
  }
  @media (max-width: 1920px) {
    width: 100% !important;
    height: 192px !important;
  }
  @media (max-width: 1366px) {
    width: 100% !important;
    height: 175px !important;
  }
  @media (max-width : 600px) {
    width: 100% !important;
    height: 180px !important;
  }
  @media (max-width: 1180px) {
    width: 350px !important;
    height: 180px !important;
  }

  @media (max-width: 412px) {
    width: 100% !important;
    height: 180px !important;
  }
`;

export const StyledListNewsCard = styled(Card)`
  width: 100%;
  border: 0.5px solid lightgrey;

  @media (max-width: 769px) {
    width: 100%;
  }
`;

export const StyledParagraph = styled(Paragraph)`
  width: 100vh;

  @media (max-width: 769px) {
    width: 100%;
  }
`;

export const TitleContent = styled(Content)`
height: 80px;
width: 100%;

@media (max-width: 1366px) {
    height: 60px;
    width: 100%;
  }

  @media (min-width: 2560px) {
    height: 150px;
    width: 100%;
  }
`

export const TitleText = styled(Paragraph)`
  //font-family: "Inria Serif";
  line-height:25px;
  font-size: 19px;
 // font-weight: 800;
  
  @media (max-width: 1366px) {
    line-height: 15px;
    font-size: 16px; /* Font size for screens 768px and below */
  }
`;
export const NewsCardButton = styled(Button)`
  /* padding: 0px 0px; */
  /* margin-top: 20px; */
  font-family: "Inter";
  border-radius: 0px;
  border: none;
  /* color:#192238; */
  /* border-bottom: 1px solid #192238; */
  box-shadow: 0 0 0;

  &:hover {
    color: #192238;
  }
  &&.ant-btn-primary {
    background-color: white;
    border-color: white;
    color: #005461;
    border-radius: 0px;
    border-bottom: 0px;
    padding: 1px 4px;

    &:hover {
      background-color: white;
      border-color: white;
      color: #005461;
      border-radius: 0px;
    }
    &:disabled {
      background-color: white;
      border-color: lightgray;
      color: grey;
      border-radius: 0px;
      padding: 1px 4px;
    }
  }
`;

export const StyledModalClose = styled(Button)`
  &&.ant-btn-primary {
    background-color: rgb(25, 34, 56);
    border-color: rgb(25, 34, 56);
    color: white;
    border-radius: 3px;
    font-family: "Inter";

    &:hover {
      background-color: white;
      border-color: #192238;
      color: #192238;
    }
    &:disabled {
      background-color: lightgray;
      border-color: lightgray;
      color: white;
    }
  }
`;


